import styled, { keyframes } from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    flex-direction: column;
`;

export const Wrapper = styled.div` 
    width: 100%;
    height: auto;
    padding: 32px;

    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const ContainerFilter = styled.div`
    width: 100%;
    height: auto;
    padding: 16px;

    gap: 16px;
    display: flex;
    align-items: center;

    border-radius: 16px;
    background-color: ${theme.colors.gray.Cinza_12};
`;

export const ButtonFilter = styled.button`
    all: unset;

    width: 44px;
    height: 44px;   

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    >img {
        width: 100%;
        height: auto;
        max-width: 26px;
    }

    :hover {
        opacity: 0.7;
    }
`;

export const ContainerInputFilter = styled.div`
    width: 100%;
    height: auto;
    max-width: 15rem;
    padding: 11px 16px;

    gap: 0.5rem;
    display: flex;
    align-items: center;

    border-radius: 1.625rem;
    border: 1px solid #8A92A2;

    >img{
        width: auto;
        height: auto;

        display: flex;
        margin-top: 0.1875rem;
    }

    >input {
        all: unset;

        width: 100%;
        height: 1.375rem;

        display: flex;
        align-items: flex-start;

        ::placeholder {
            color: #8A92A2;
            font-weight: 400;
            font-size: 0.875rem;
            font-family: "Lato";
            line-height: 1.3125rem;
        }
    }

    @media (max-width: 395px) {
        >input {
            ::placeholder{
                font-size: 0.7rem;
            }
        }
    }
`

export const Content = styled.div`
    width: 100%;
    height: auto;
    padding-top: 8px;

    gap: 32px;
    display: flex;
    flex-direction: column;
`

export const ContainerTable = styled.div`
    width: 100%;
    height: auto;

    gap: ${props => props.hasGap ? '16px' : '0px'};
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    overflow-x: scroll;
    overflow-y: ${props => props.allowVerticalOverflow ? 'visible' : 'hidden'};
    scrollbar-gutter: stable;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    border-radius: 8px;
    border: 2px solid ${theme.colors.gray.Cinza_12};

    &::-webkit-scrollbar {
        width: 0;
        height: 0;
        display: none;
    }
`

export const FakeScrollbarOuter = styled.div`
    width: 100%;
    align-self: stretch;
    flex: 0 0 auto;
    position: sticky;
    left: 0;
    bottom: 0;
    z-index: 4;
    margin-top: 4px;
    padding: 0 0 6px;
    box-sizing: border-box;
    background: #fff;
`

export const FakeScrollbarTrack = styled.div`
    width: 100%;
    height: 8px;
    position: relative;
    background: rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    cursor: pointer;
`

export const FakeScrollbarInner = styled.div`
    height: 8px;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 8px;
    background: rgba(31, 41, 55, 0.45);
    transition: transform 0.08s linear;
    cursor: ${props => (props.active ? 'grabbing' : 'grab')};
    user-select: none;
    touch-action: none;
`

export const ContainerTableRow = styled.div`
    width: 100%;
    /* width: auto; */
    height: auto;
    padding: 12px;

    gap: 8px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    flex-direction: row;

    cursor: ${props => props.status === 'error' ? 'not-allowed' : props.cursor === true ? 'pointer' : 'default'};
    /* border-radius: ${props => props.firstChild ? '8px 8px 0px 0px' : props.lastChild ? '0px 0px 8px 8px' : '0px'}; */
    border-bottom: ${props => props.lastChild ? 'none' : `2px solid ${theme.colors.gray.Cinza_12}`};
    background-color: ${props => props.status === 'error' ? theme.colors.disabled.Fundo_Desabilitado : "transparent"};

    >div:nth-of-type(3){
        max-width: 240px;
        min-width: 240px;
    }

    >p{
        padding-right: 8px;

        white-space: nowrap;
    }

    >p:nth-of-type(2){
        padding-right: 4px;
    }
`

export const ContainerTableColumn = styled.div`
    width: max-content;
    min-width: 100%;
    height: auto;

    display: flex;

    >div:first-child{
        >div{
            padding: 12px 8px 12px 12px;

            /* border-radius: 8px 0px 0px 0px; */
        }
    }

    >div:last-child{
        >div{
            padding: 12px 12px 12px 8px;

            /* border-radius: 0px 8px 0px 0px; */
        }
    }

    >div{
        >div:first-child{
            >div{
                border-radius: 8px 0px 0px 0px;
            }
        }

        >div:last-child{
            >div{
                border-radius: 0px 8px 0px 0px;
            }
        }
    }
`;

export const ContainerInfoTopBlack = styled.div`
    width: 100%;
    /* width: 1471px; */
    height: auto;

    gap: 8px;
    display: flex;

    background-color: ${theme.colors.gray.Cinza_2};
    
    >div{
        /* padding: 8px 12px; */
        /* background-color: ${theme.colors.gray.Cinza_2}; */
    }
`;

export const ContainerInfoTopLabel = styled.div`
    width: ${props => props.width ? `${props.width} !important` : 'auto'};
    /* min-width: ${props => props.minWidth ? `${props.minWidth} !important` : 'auto'}; */
    height: auto;
    max-width: ${props => props.maxWidth ? props.maxWidth : '100%'};
    padding: ${props => props.padding ? props.padding : '0'};

    display: flex;

    >p{
        white-space: nowrap;
    }
`;

export const ContainerCard = styled.div`
    width: 100%;
    height: auto;

    gap: 9px;
    display: flex;
    flex-direction: column;
`

export const TableRowCell = styled.div`
    width: ${props => props.width ? props.width : props.enableHorizontalScroll ? '100%' : 'auto'};
    max-width: ${props => props.maxWidth ? props.maxWidth : 'none'};
    min-width: ${props => props.minWidth ? props.minWidth : 'auto'};
    height: auto;
    padding-right: ${props => props.showScrollHint ? '14px' : '0px'};

    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: ${props => props.JustifyContent ? props.JustifyContent : 'none'};

    overflow-x: ${props => props.enableHorizontalScroll ? 'auto' : 'hidden'};
    overflow-y: hidden;
    scrollbar-gutter: stable;
    -webkit-overflow-scrolling: touch;

    >p{
        white-space: nowrap;
    }

    >div>p{
        white-space: nowrap;
    }

    ::after{
        content: '';
        display: ${props => props.showScrollHint ? 'block' : 'none'};
        width: 22px;
        height: calc(100% - 2px);
        position: sticky;
        right: -1px;
        top: 0;
        margin-left: -22px;
        pointer-events: none;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 80%);
    }

    /* width */
    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        -webkit-appearance: none;
    }

    &::-webkit-scrollbar-button {
        width: 0;
        height: 0;
        display: none;
    }

    /* Track */
    &::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.08);
        border-radius: 8px;
    }
    
    /* Handle */
    &::-webkit-scrollbar-thumb {
        background: rgba(31, 41, 55, 0.45);
        border-radius: 8px;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
        background: rgba(31, 41, 55, 0.7);
    }
`

export const ContainerRowCellSmall= styled.div` 
    height: auto;
    min-width: 65px;
    max-width: 240px;
    padding-right: 13px;
 
    gap: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const TableRowCellSmall = styled.div`
    width: auto;
    height: auto;
    min-width: ${props => props.minWidth ? props.minWidth : 'auto'};
    padding-right: ${props => props.paddingRight ? props.paddingRight : '13px'};

    display: flex;
    align-items: center;
`

export const TableRow = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    justify-content: space-between;
`

export const TableRowContain = styled.div`
    width: auto;
    height: auto;

    gap: 8px;
    display: flex;
    align-items: center;
`

//Container das Células
export const ContainerRT = styled.div`
    min-width: 120px;
    height: auto;

    display: flex;
    align-items: flex-start;
`

export const ContainerProdutor = styled.div`
    min-width: 120px;
    height: auto;

    display: flex;
    align-items: flex-start;
`

export const ContainerLocalAplicação = styled.div`
    min-width: 160px;
    height: auto;

    display: flex;
    align-items: flex-start;
`

export const ContainerCultura = styled.div`
    min-width: 120px;
    height: auto;

    display: flex;
    align-items: flex-start;
`

export const ContainerTableColumnV2 = styled.div`
    width: ${props => props.width ? props.width : 'auto'};
    height: auto;
    min-width: ${props => props.minWidth ? props.minWidth : 'auto'};
    max-width: ${props => props.maxWidth ? props.maxWidth : 'none'};
    flex: ${props => String(props.width).trim() === '100%' ? '1 1 0' : '0 0 auto'};
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
`

export const ContainerColumnInfoTopBlack = styled.div`
    width: 100%;
    height: auto;
    padding: 12px 8px;
    min-width: ${props => props.minWidth ? props.minWidth : 'auto'};
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    align-items: flex-start;

    /* border-right: 1px solid rgba(255, 255, 255, 0.35); */
    background-color: ${theme.colors.gray.Cinza_2};
`

export const ContainerColumnCellContent = styled.div`
    width: 100%;
    max-width: ${props => props.maxWidthContent ? props.maxWidthContent : 'auto'};
    height: ${props => props.height ? `${props.height}px` : 'auto'};
    padding: 12px 8px;
    box-sizing: border-box;

    gap: 8px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    flex-direction: row;

    /* overflow-x: hidden; */

    cursor: ${props => props.status === 'error' ? 'not-allowed' : props.cursor === true ? 'pointer' : 'default'};
    /* border-radius: ${props => props.firstChild ? '8px 8px 0px 0px' : props.lastChild ? '0px 0px 8px 8px' : '0px'}; */
    border-bottom: ${props => props.lastChild ? 'none' : `2px solid ${theme.colors.gray.Cinza_12}`};
    background-color: ${props => props.status === 'error' ? theme.colors.disabled.Fundo_Desabilitado : "transparent"};

    >div:nth-of-type(3){
        max-width: 240px;
        min-width: 240px;
    }

    >p{
        padding-right: 8px;

        white-space: nowrap;
    }

    >p:nth-of-type(2){
        padding-right: 4px;
    }
`

export const CheckboxInput = styled.input`
    width: 18px;
    height: 18px;
    appearance: none;
    border: 1px solid ${theme.colors.gray.Cinza_11};
    border-radius: 4px;
    cursor: pointer;
    background-color: ${theme.colors.gray.Cinza_13};
    transition: background-color 0.3s, border-color 0.3s;

    &:checked {
      background-color: ${theme.colors.green.Verde_AgroReceita};
      border-color: ${theme.colors.green.Verde_AgroReceita};

      &::after {
        content: "✔";
        color: white;
        font-size: 11px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
`;
